// extracted by mini-css-extract-plugin
module.exports = {"wrapperError":"CustomChipInput_wrapperError__1FmV7"};